import { call, put } from 'redux-saga/effects'

import { cropperValid, cropperInvalid, cropperError } from 'actions/cropper'
import { readAsDataURL, getImageDimensions } from 'utils/filereader'
import { generateUUID } from 'utils/uuid'
import { CROPPER_MIN_IMAGE_WIDTH, CROPPER_MIN_IMAGE_HEIGHT } from 'constants/cropper-tool-constants'

/* eslint-disable import/prefer-default-export */
export function* readCropperFile({ file }) {
  try {
    const data = yield call(readAsDataURL, file)
    const size = yield call(getImageDimensions, data)
    if (size.width < CROPPER_MIN_IMAGE_WIDTH || size.height < CROPPER_MIN_IMAGE_HEIGHT) {
      const error = {
        id: generateUUID(),
        type: 'FORM',
        detail: {
          message: `The image selected does not meet the minimum requirements. It must be at ` +
                   `least ${CROPPER_MIN_IMAGE_WIDTH}x${CROPPER_MIN_IMAGE_HEIGHT} pixels in size.`,
        },
      }
      yield put(cropperInvalid(file, error))
    } else {
      yield put(cropperValid(file, data))
    }
  } catch (error) {
    yield put(cropperError(file, error))
  }
}



/** WEBPACK FOOTER **
 ** ./src/sagas/cropper/cropper-sagas.js
 **/